<script>
  import Sublevel from "./Sublevel.svelte";
  import {
    activeClass,
    exactClass,
    link,
    isActiveLink,
  } from "../../../../../core";
  import type { ITreeNavigationItem } from "./List.svelte";

  export let url: string;
  export let title: string;
  export let children: ITreeNavigationItem[];

  let isSublevelShowed: boolean = isActiveLink(url);

  function toggleSublevel(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    isSublevelShowed = !isSublevelShowed;
  }
</script>

<div class="main-level-item">
  <a
    class="main-menu-link"
    class:showSublevel={isSublevelShowed}
    use:link
    use:exactClass={"active-nav-mob-exact"}
    use:activeClass={"active-nav-mob"}
    on:click
    href={url}
  >
    {title}

    {#if children.length}
      <button class="main-menu-link__button" on:click={toggleSublevel}>
        <svg class="icon" width="10" height="16" aria-label="has children">
          <use xlink:href="#nav-arrow" />
        </svg>
      </button>
    {/if}
  </a>

  {#if children.length}
    <Sublevel {children} on:click />
  {/if}
</div>

<style lang="scss">
  .main-level-item {
    display: block;
    font-size: 16px;
    line-height: 1;
    font-weight: 900;
    margin-bottom: 14px;
    padding-bottom: 14px;
    border-bottom: 1px solid $text-reverse-color;
  }

  .main-menu-link {
    display: flex;
    justify-content: space-between;
    color: $text-reverse-color;
    text-decoration: none;
    text-transform: uppercase;

    &__button {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  :global(.active-nav-mob) {
    border-left: 4px solid #2e969b;
    padding-left: 12px;
  }

  :global(.showSublevel + .sublevel) {
    display: block !important;
  }

  .showSublevel {
    .main-menu-link__button {
      transform: rotate(90deg);
    }
  }
</style>
